import { useWindowSize } from "src/lib/use-window-size";
import { random } from "lodash";
import { keyframes } from "@emotion/react";
import { useMemo } from "react";

export const animationConfig = {
  amountOfObjects: 100,
  size: 10,
  durationInSeconds: 120,
};

const keyframesFromScreenSize = (screenWidth: number, screenHeight: number) => {
  const moveToRandomPosition = () =>
    `translate(${random(screenHeight)}px, ${random(screenWidth)}px)`;

  return keyframes`
    from {
      opacity: 0;
      transform: ${moveToRandomPosition()};
    }
    
    5% {
      opacity: 1;
      transform: scale(1.2) ${moveToRandomPosition()};
    }
    
    25% {
      transform: ${moveToRandomPosition()};
    }
    
     35% {
        transform: ${moveToRandomPosition()};
     }
      
     45% {
        transform: ${moveToRandomPosition()};
     }
      
     55% {
        transform: ${moveToRandomPosition()};
     }
      
     65% {
        transform: ${moveToRandomPosition()};
     }

    to {
      opacity: 0;
      transform: scale(1) ${moveToRandomPosition()};
    }
`;
};

const randomScreenPosition = (
  screenWidth: number,
  screenHeight: number,
  borderSize: number
) => ({
  top: random(screenHeight - borderSize),
  bottom: random(screenHeight - borderSize),
  left: random(screenWidth - borderSize),
  right: random(screenWidth - borderSize),
});

export const useFloatAnimation = () => {
  const { width = 0, height = 0 } = useWindowSize();

  const floatKeyframes = useMemo(
    () =>
      keyframesFromScreenSize(
        width - animationConfig.size,
        height - animationConfig.size
      ),
    [width, height]
  );

  const initialPosition = useMemo(
    () => randomScreenPosition(width, height, animationConfig.size),
    [width, height]
  );

  return {
    floatKeyframes,
    screenHeight: height,
    screenWidth: width,
    initialPosition,
    durationInSeconds: animationConfig.durationInSeconds,
  };
};
